import z from 'zod'

export const envSchema = z.object({
  REACT_APP_START_MODE: z.enum(['DEBUG', 'NULL']).default('NULL').optional(),
  REACT_APP_OSS_BUCKET: z.string(),
  // REACT_APP_SITE_HOST: z.url(),
  REACT_APP_NODE_ENV: z
    .enum(['dev', 'test', 'production'])
    .default('dev')
    .optional(),
  // REACT_APP_HZERO_PREFIX: z.url(),
  REACT_APP_PUBLIC_DATA: z.url(),
  REACT_APP_HSY_URL: z.url(),
  // REACT_APP_HSY_TAXNO: z.string(),
  REACT_APP_PREVIEW_SERVER_URL: z.url(),
})

export const globalEnvConfig = envSchema.parse({
  REACT_APP_START_MODE: process.env.REACT_APP_START_MODE,
  REACT_APP_OSS_BUCKET: process.env.REACT_APP_OSS_BUCKET,
  // REACT_APP_SITE_HOST: process.env.REACT_APP_SITE_HOST,
  REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_PUBLIC_DATA: process.env.REACT_APP_PUBLIC_DATA,
  REACT_APP_HSY_URL: process.env.REACT_APP_HSY_URL,
  // REACT_APP_HSY_TAXNO: process.env.REACT_APP_HSY_TAXNO,
  // REACT_APP_HZERO_PREFIX: process.env.REACT_APP_HZERO_PREFIX,
  REACT_APP_PREVIEW_SERVER_URL: process.env.REACT_APP_PREVIEW_SERVER_URL,
})

export type GlobalEnvConfig = z.infer<typeof envSchema>
import z from 'zod'

export const envSchema = z.object({
  REACT_APP_START_MODE: z.enum(['DEBUG', 'NULL']).default('NULL').optional(),
  REACT_APP_OSS_BUCKET: z.string(),
  // REACT_APP_SITE_HOST: z.url(),
  REACT_APP_NODE_ENV: z
    .enum(['dev', 'test', 'production'])
    .default('dev')
    .optional(),
  // REACT_APP_HZERO_PREFIX: z.url(),
  REACT_APP_PUBLIC_DATA: z.url(),
  REACT_APP_HSY_URL: z.url(),
  // REACT_APP_HSY_TAXNO: z.string(),
  REACT_APP_PREVIEW_SERVER_URL: z.url(),
})

export const globalEnvConfig = envSchema.parse({
  REACT_APP_START_MODE: process.env.REACT_APP_START_MODE,
  REACT_APP_OSS_BUCKET: process.env.REACT_APP_OSS_BUCKET,
  // REACT_APP_SITE_HOST: process.env.REACT_APP_SITE_HOST,
  REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_PUBLIC_DATA: process.env.REACT_APP_PUBLIC_DATA,
  REACT_APP_HSY_URL: process.env.REACT_APP_HSY_URL,
  // REACT_APP_HSY_TAXNO: process.env.REACT_APP_HSY_TAXNO,
  // REACT_APP_HZERO_PREFIX: process.env.REACT_APP_HZERO_PREFIX,
  REACT_APP_PREVIEW_SERVER_URL: process.env.REACT_APP_PREVIEW_SERVER_URL,
})

export type GlobalEnvConfig = z.infer<typeof envSchema>
